import { Runtime } from '../api';
import type { Long } from '../api';
import type { Settings } from '@huolala-tech/nad-runtime';

/**
 * 批量查询客户 COMMENT(备注)事件数量。
 * 对应后端 POST /company/{companyId}/customers/comment_count。
 * 返回 { [customerId]: count }，无备注的客户不在返回中。
 * 注意：本接口为手写定义（不经 nad-cli 生成）。
 */
export async function getCommentCount(
  companyId: Long,
  id: Long[],
  settings?: Partial<Settings>,
): Promise<Record<string, number>> {
  return new Runtime<Record<string, number>>()
    .open('POST', '/company/{companyId}/customers/comment_count', settings)
    .addPathVariable('companyId', companyId)
    .addRequestParam('id', id)
    .execute();
}
